<template>
    <div>
        <h2 class="ix-page-title-secondary mt-4">Approvisionnement</h2>
        <div class="row">
            <div class="form-group col-md-3">
                <label for="reference_lead_time">
                    Délai d'appro. de référence
                    <i class="fas fa-question-circle text-muted" v-b-tooltip.hover title="Si vide, délai du fournisseur le plus rapide."></i>
                </label>
                <div class="input-group">
                    <input type="number" step="1" min="0" max="999" class="form-control" :class="{'is-invalid': referenceLeadTimeError}" id="reference_lead_time" name="reference_lead_time" v-model="reference_lead_time">
                    <div class="input-group-append">
                        <span class="input-group-text">j</span>
                    </div>
                    <div class="invalid-feedback" v-if="referenceLeadTimeError">{{ referenceLeadTimeError }}</div>
                </div>
            </div>
        </div>
        <div class="ix-table-box mb-3">
            <table class="ix-table">
                <thead>
                <tr>
                    <th style="width: 30px;"></th>
                    <th>Fournisseur</th>
                    <th>Référence</th>
                    <th>Prix d'achat</th>
                    <th style="width: 150px;">Délai</th>
                    <th>Code EAN</th>
                    <th>Indications</th>
                    <th class="text-center"><i class="far fa-star"></i></th>
                    <th style="width: 120px;"></th>
                </tr>
                </thead>
                <draggable v-model="providers" tag="tbody" handle=".handle-line" v-if="!loading">
                    <tr v-for="(provider, index) in providers" is="article-provider-form"
                        v-bind:key="provider.uniq"
                        :provider="provider"
                        :index="index"
                        :companiesRoute="companiesRoute"
                        v-on:provider-editing-started="checkIfNewRowNeeded($event)"
                        v-on:provider-deleted="deleteRow($event)"
                        v-on:provider-favorited="disableFavorites($event)"
                    ></tr>
                </draggable>
            </table>
        </div>

        <button type="button" class="ix-btn link" @click="addRow(null)"><i class="far fa-plus"></i> Nouveau fournisseur</button>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import ArticleProviderForm from "./ArticleProviderForm";

    export default {
        name: 'article-provider-table-form',
        props: ['oldProviders', 'companiesRoute', 'oldReferenceLeadTime', 'referenceLeadTimeError'],
        components : {
            ArticleProviderForm,
            draggable
        },
        data() {
            return {
                loading: true,
                providers: [],
                reference_lead_time: this.oldReferenceLeadTime
            };
        },
        methods : {
            disableFavorites : function (indexToKeep) {
                this.providers.forEach((provider, index) => {
                    if (index != indexToKeep) {
                        this.providers[index].is_favorite = 0
                    }
                });
            },
            addRow: function (provider) {
                var data = {
                    id: null,
                    uniq: Math.random().toString(36).substr(2, 9),
                    company_name: '',
                    company_id: null,
                    reference: '',
                    amount: 0,
                    lead_time: '',
                    observed_lead_time: null,
                    description: '',
                    ean: '',
                    is_favorite: 0,
                }

                if (provider != null) {
                    data.id = provider.id
                    data.company_name = provider.company_name
                    data.company_id = provider.company_id
                    data.reference = provider.reference
                    data.amount = provider.amount
                    data.lead_time = provider.lead_time === null || provider.lead_time === undefined ? '' : provider.lead_time
                    data.observed_lead_time = provider.observed_lead_time || null
                    data.description = provider.description
                    data.ean = provider.ean
                    data.is_favorite = provider.is_favorite
                }

                this.providers.push(data)
            },
            deleteRow: function (index) {
                this.providers.splice(index, 1)
                if (this.providers.length == 0) {
                    this.addRow()
                }
            },
            checkIfNewRowNeeded: function (index) {
                if (this.providers.length > 0) {
                    if (this.providers.length - 1 == index) {
                        this.addRow()
                    }
                }
            },
            getProviders: async function (route) {
                this.loading = true;
                fetch(route, {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    return response.json();
                }).then((data) => {
                    data.forEach(provider => {
                        this.addRow(provider)
                    })
                    this.addRow(null)
                    this.loading = false
                }).catch(error => {
                    console.log(error)
                });
            }
        },
        mounted(){
            const jsonProviderBackup = JSON.parse(this.oldProviders)
            if (Array.isArray(jsonProviderBackup)) {
                if (jsonProviderBackup.length == 0) {
                    this.addRow(null)
                } else {
                    jsonProviderBackup.forEach(provider => {
                        this.addRow(provider)
                    })
                }
                this.loading = false
            } else {
                this.getProviders(jsonProviderBackup)
            }
        }
    }
</script>
